// const formDataSchema = Object.seal({
//     feilds: [{
//         id: 1,
//         name: 'name',
//         title: 'Name *',
//         visible: true,
//         element: 'input',
//         required: true,
//         input_type: 'text',
//         placeholder: 'Enter',
//         icon: 'user',
//         rules: [
//             {
//                 test: (value) => {
//                     return (value !== null && value.length > 0);
//                 },
//                 message: 'Please Enter Name'
//             }
//         ],
//         errors: [],
//         value: null,
//         valid: false,
//         state: '',
//         disable: false,
//         className: 'col-4'
//     },
//     {
//         id: 2,
//         name: "password",
//         text: "Enter User Password",
//         visible: true,
//         element: "input",
//         required: true,
//         input_type: "password",
//         placeholder: "Enter user Password",
//         icon: "lock",
//         rules: [
//           {
//             test: (value) => {
//               return value !== null && value.length > 0;
//             },
//             message: "Please Enter Your password",
//           },
//         ],
//         errors: [],
//         value: null,
//         valid: false,
//         state: "",
//         disable: false,
//         className: 'col-4'
//       },
//     {
//         id: 5,
//         name: 'unit',
//         title: 'Unit *',
//         visible: true,
//         element: 'select2',
//         required: true,
//         input_type: 'select',
//         placeholder: 'Select',
//         icon: 'user',
//         rules: [
//             {
//                 test: (value) => {
//                     return (value !== null && value.length > 0);
//                 },
//                 message: 'Please Select Unit'
//             }
//         ],
//         errors: [],
//         value: null,
//         valid: false,
//         state: '',
//         disable: false,
//         className: 'col-4'
//     },
//     {
//         id: 7,
//         name: 'user_id',
//         title: 'User ID *',
//         visible: true,
//         element: 'input',
//         required: true,
//         input_type: 'text',
//         placeholder: 'Enter',
//         icon: 'number',
//         rules: [
//             {
//                 test: (value) => {
//                     return (value !== null && value.length > 0)

//                 },
//                 message: 'Please Enter User ID'
//             }
//         ],
//         errors: [],
//         value: null,
//         valid: false,
//         state: '',
//         disable: false,
//         className: 'col-4'
//     }, {
//         id: 8,
//         name: 'password',
//         title: 'Password *',
//         visible: true,
//         element: 'input',
//         required: true,
//         input_type: 'text',
//         placeholder: 'Enter',
//         icon: 'user',
//         rules: [
//             {
//                 test: (value) => {

//                     return (value !== null && value.length > 0);

//                 },
//                 message: 'Please Enter Password'
//             }
//         ],
//         errors: [],
//         value: null,
//         valid: false,
//         state: '',
//         disable: false,
//         className: 'col-4'
//     }, {
//         id: 6,
//         name: 'role_id',
//         title: 'Role *',
//         visible: true,
//         element: 'select2',
//         required: true,
//         input_type: 'select',
//         placeholder: 'Select',
//         icon: 'user',
//         rules: [
//             {
//                 test: (value) => {
//                     return (value !== null && value.length > 0);
//                 },
//                 message: 'Please Select Role'
//             }
//         ],
//         errors: [],
//         value: null,
//         valid: false,
//         state: '',
//         disable: false,
//         className: 'col-4'
//     }, {
//         id: 9,
//         name: 'otroom',
//         title: 'OT Room *',
//         visible: false,
//         element: 'Select2multiple',
//         required: true,
//         input_type: 'select',
//         placeholder: 'Select',
//         icon: 'user',
//         rules: [
//             {
//                 test: (value) => {
//                     return (value !== null && value.length > 0);
//                 },
//                 message: 'Please Select OT Room'
//             }
//         ],
//         errors: [],
//         value: null,
//         valid: false,
//         state: '',
//         disable: false,
//         className: 'col-8'
//     }
//     ,{
//         id: 10,
//         name: 'doctor_id',
//         title: 'Doctor ID *',
//         visible: true,
//         element: 'input',
//         required: true,
//         input_type: 'text',
//         placeholder: 'Enter',
//         icon: 'number',
//         rules: [
//             {
//                 test: (value) => {
//                     return (value !== null && value.length > 0)

//                 },
//                 message: 'Please Enter Doctor ID'
//             }
//         ],
//         errors: [],
//         value: null,
//         valid: false,
//         state: '',
//         disable: false,
//         className: 'col-4'
//     },{
//         id: 11,
//         name: 'secretary_doctor_ids',
//         title: 'Doctor Name*',
//         visible: true,
//         element: 'Select2multiple',
//         required: true,
//         input_type: 'select',
//         placeholder: 'Enter',
//         icon: 'number',
//         rules: [
//             {
//                 test: (value) => {
//                     return (value !== null && value.length > 0)

//                 },
//                 message: 'Please Select Doctor Name'
//             }
//         ],
//         errors: [],
//         value: null,
//         valid: false,
//         state: '',
//         disable: false,
//         className: 'col-8'
//     }
//     ]
// })
const formDataSchema = {
  feilds: [
    {
      id: 0,
      name: "addUser",
      text: "Add New User",
      visible: true,
      element: "label",
      className: [],
      required: false,
    },
    {
      id: 1,
      name: "userName",
      text: "Enter User Name",
      visible: true,
      element: "input",
      required: true,
      input_type: "text",
      placeholder: "Enter user Name",
      icon: "user",
      rules: [
        {
          test: (value) => {
            return value !== null && value.length > 0;
          },
          message: "Please Enter Your User Name",
        },
      ],
      errors: [],
      value: null,
      valid: false,
      state: "",
      disable: false,
      className: "",
    },
    {
      id: 9,
      name: "rh_userid",
      text: "User Id",
      visible: true,
      element: "input",
      required: true,
      input_type: "text",
      placeholder: "Enter User ID",
      icon: "user",
      rules: [
        {
          test: (value) => {
            return value !== null && value.length > 0;
          },
          message: "Please Enter  User ID",
        },
      ],
      errors: [],
      value: null,
      valid: false,
      state: "",
      disable: false,
      className: "",
    },
    {
      id: 2,
      name: "password",
      text: "Enter User Password",
      visible: true,
      element: "input",
      required: true,
      input_type: "password",
      placeholder: "Enter user Password",
      icon: "lock",
      rules: [
        {
          test: (value) => {
            return value !== null && value.length > 0;
          },
          message: "Please Enter Your password",
        },
      ],
      errors: [],
      value: null,
      valid: false,
      state: "",
      disable: false,
      className: "",
    },
    {
      id: 3,
      name: "role",
      text: "Select Role",
      visible: true,
      element: "select2",
      required: true,
      input_type: "text",
      placeholder: "Select Role",
      icon: "lock",
      rules: [
        {
          test: (value) => {
            return value !== null && value.length > 0;
          },
          message: "Please Select Role",
        },
      ],
      errors: [],
      value: null,
      valid: false,
      state: "",
      disable: false,
      className: "",
    },
    // {
    //   id: 5,
    //   name: "unit",
    //   text: "Select Unit",
    //   visible: false,
    //   element: "select2",
    //   required: true,
    //   input_type: "text",
    //   placeholder: "Select Unit",
    //   icon: "lock",
    //   rules: [
    //     {
    //       test: (value) => {
    //         return value && value !== null && value.length > 0;
    //       },
    //       message: "Please Select Unit",
    //     },
    //   ],
    //   errors: [],
    //   value: null,
    //   valid: false,
    //   state: "",
    //   disable: true,
    //   className: "",
    // },
    {
      id: 5,
      name: "unit",
      text: "Select Unit",
      visible: true,
      element: "Select2multiple",
      required: true,
      input_type: "text",
      placeholder: "Select Unit",
      icon: "lock",
      rules: [
        {
          test: (value) => {
            return value !== null && value.length > 0;
          },
          message: "Please Select Unit",
        },
      ],
      errors: [],
      value: null,
      valid: false,
      state: "",
      disable: true,
      className: "",
    },
    //   {
    //     id: 7,
    //     name: "department",
    //     text: "Select Department",
    //     visible: true,
    //     element: "select2",
    //     required: true,
    //     input_type: "text",
    //     placeholder: "Select Department",
    //     icon: "lock",
    //     rules: [
    //       {
    //         test: (value) => {
    //           return value !== null && value.length > 0;
    //         },
    //         message: "Please Select Department",
    //       },
    //     ],
    //     errors: [],
    //     value: null,
    //     valid: false,
    //     state: "",
    //     disable: true,
    //     className: 'col-4'
    //   },
    //   {
    //     id: 8,
    //     name: "service",
    //     text: "Select Service Group",
    //     visible: true,
    //     element: "select2",
    //     required: true,
    //     input_type: "text",
    //     placeholder: "Select Service Group",
    //     icon: "lock",
    //     rules: [
    //       {
    //         test: (value) => {
    //           return value !== null && value.length > 0;
    //         },
    //         message: "Please Service Group",
    //       },
    //     ],
    //     errors: [],
    //     value: null,
    //     valid: false,
    //     state: "",
    //     disable: true,
    //     className: 'col-4'
    //   },
    {
      id: 6,
      name: "work_station",
      text: "Select Work Station",
      visible: false,
      element: "select2",
      required: true,
      input_type: "text",
      placeholder: "Select Work Station",
      icon: "lock",
      rules: [
        {
          test: (value) => {
            return value !== null && value.length > 0;
          },
          message: "Please Work Station",
        },
      ],
      errors: [],
      value: null,
      valid: false,
      state: "",
      disable: true,
      className: "",
    },
    {
      id: 7,
      name: "doctor_user_id",
      text: "Doctor User Id",
      visible: false,
      element: "input",
      required: true,
      input_type: "text",
      placeholder: "Enter  Doctor User Id",
      icon: "user",
      rules: [
        {
          test: (value) => {
            return value !== null && value.length > 0;
          },
          message: "Please Enter  Doctor User Id",
        },
      ],
      errors: [],
      value: null,
      valid: false,
      state: "",
      disable: true,
      className: "",
    },
    {
      id: 8,
      name: "button",
      text: "User",
      visible: true,
      required: false,
      element: "button",
      input_type: "button",
      disable: false,
    },
  ],
};

const departmentForm = {
  feilds: [
    
    {
      id: 1,
      name: "name",
      text: "Enter Department Name",
      visible: true,
      element: "input",
      required: true,
      input_type: "text",
      placeholder: "Enter Department Name",
      icon: "user",
      rules: [
        {
          test: (value) => {
            return value !== null && value.length > 0;
          },
          message: "Please Enter Your Department Name",
        },
      ],
      errors: [],
      value: null,
      valid: false,
      state: "",
      disable: false,
      className: [],
    }
  ],
};

export { formDataSchema,departmentForm };
